import {
  container,
  cardTitle,
  grayColor,
  infoColor,
  blackColor,
  hexToRgb,
} from "assets/jss/material-dashboard-pro-react.js";

import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

/**
 * Estilos de la pantalla de login.
 *
 * Objetivos:
 * - mantener el responsive trabajado en la rama responsive
 * - conservar el soporte añadido en main para copyrightContainer
 * - evitar márgenes rígidos y padding frágil
 */
const loginPageStyle = {
  ...customCheckboxRadioSwitch,

  cardTitle: {
    ...cardTitle,
    textAlign: "center",
  },

  container: {
    ...container,
    position: "relative",
    zIndex: "3",
    marginTop: 0,
    paddingLeft: "15px",
    paddingRight: "15px",

    "@media (max-width: 960px)": {
      paddingLeft: "12px",
      paddingRight: "12px",
    },

    "@media (max-width: 600px)": {
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },

  cardSignup: {
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(" +
      hexToRgb(blackColor) +
      ", 0.14), 0 6px 30px 5px rgba(" +
      hexToRgb(blackColor) +
      ", 0.12), 0 8px 10px -5px rgba(" +
      hexToRgb(blackColor) +
      ", 0.2)",
    marginTop: "48px",
    marginBottom: "48px",
    padding: "32px 0",

    "@media (max-width: 960px)": {
      marginTop: "32px",
      marginBottom: "32px",
      padding: "24px 0",
    },

    "@media (max-width: 600px)": {
      marginTop: "20px",
      marginBottom: "20px",
      padding: "18px 0",
    },
  },

  center: {
    textAlign: "center",
  },

  right: {
    textAlign: "right",
  },

  left: {
    textAlign: "left",
  },

  form: {
    padding: "0 24px",
    paddingTop: 0,
    position: "relative",

    "@media (max-width: 960px)": {
      padding: "0 18px",
    },

    "@media (max-width: 600px)": {
      padding: "0 12px",
    },
  },

  socialTitle: {
    fontSize: "18px",

    "@media (max-width: 600px)": {
      fontSize: "16px",
    },
  },

  inputAdornment: {
    marginRight: "18px",
    position: "relative",

    "@media (max-width: 600px)": {
      marginRight: "12px",
    },
  },

  inputAdornmentIcon: {
    color: grayColor[6],
  },

  customFormControlClasses: {
    margin: "0 12px",

    "@media (max-width: 600px)": {
      margin: "0 6px",
    },
  },

  checkboxLabelControl: {
    margin: "0",
    alignItems: "flex-start",
  },

  checkboxLabel: {
    fontSize: "0.875rem",
    marginLeft: "6px",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.26)",
    lineHeight: "1.4",

    "@media (max-width: 600px)": {
      fontSize: "0.8rem",
    },
  },

  createAccText: {
    color: infoColor[4],
  },

  socialContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop: 32,
    gap: 16,

    "@media (max-width: 600px)": {
      marginTop: 24,
      gap: 12,
    },
  },

  socialIcon: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    objectFit: "cover",
    cursor: "pointer",
    transition: "transform 0.2s ease",

    "&:hover": {
      transform: "scale(1.1)",
    },

    "@media (max-width: 600px)": {
      width: 36,
      height: 36,
    },
  },

  copyrightContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
    marginBottom: -20,

    "@media (max-width: 600px)": {
      marginTop: 16,
      marginBottom: -12,
    },
  },
};

export default loginPageStyle;